export default {
  sidebar: '54px',
  sidebar__opened: '190px',
  sidebarSize: { open: '240px', closed: '54px' },
  header: '88px',
}
